/**
 * <s-gallery-counter> — Tracks which slide of a horizontally scrolling gallery is in view.
 *
 * Required child markup:
 *   [data-gallery-track]   — The horizontal scroller; each direct child is one slide.
 *   [data-gallery-current] — Text node updated with the 1-based index of the visible slide.
 *   [data-gallery-progress] (optional) — Bar whose inline-start offset follows the visible slide.
 */
class SGalleryCounter extends HTMLElement {
  #ac;

  connectedCallback() {
    const track = this.querySelector('[data-gallery-track]');
    const current = this.querySelector('[data-gallery-current]');
    const progress = this.querySelector('[data-gallery-progress]');
    if (!track || !current) return;

    this.#ac = new AbortController();
    const total = track.children.length || 1;
    let frame = 0;

    const update = () => {
      frame = 0;
      const width = track.clientWidth || 1;
      const scroll = Math.abs(track.scrollLeft);
      const index = Math.min(total - 1, Math.max(0, Math.round(scroll / width)));
      current.textContent = String(index + 1);
      if (progress) {
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        progress.style.transform = `translateX(${direction * index * 100}%)`;
      }
    };

    track.addEventListener(
      'scroll',
      () => {
        if (!frame) frame = requestAnimationFrame(update);
      },
      { passive: true, signal: this.#ac.signal }
    );
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-gallery-counter')) {
  customElements.define('s-gallery-counter', SGalleryCounter);
}
